import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const PACK = 'MEGAPACK Química Visual';
const purchases = [{
  name: 'María S.',
  location: 'Ciudad de México, México',
  pack: PACK,
  time: 'hace 2 min'
}, {
  name: 'Juan P.',
  location: 'Guadalajara, México',
  pack: PACK,
  time: 'hace 4 min'
}, {
  name: 'Camila R.',
  location: 'Bogotá, Colombia',
  pack: PACK,
  time: 'hace 6 min'
}, {
  name: 'Andrés M.',
  location: 'Medellín, Colombia',
  pack: PACK,
  time: 'hace 8 min'
}, {
  name: 'Lucía T.',
  location: 'Lima, Perú',
  pack: PACK,
  time: 'hace 9 min'
}, {
  name: 'Diego F.',
  location: 'Santiago, Chile',
  pack: PACK,
  time: 'hace 11 min'
}, {
  name: 'Sofía G.',
  location: 'Buenos Aires, Argentina',
  pack: PACK,
  time: 'hace 13 min'
}, {
  name: 'Martín L.',
  location: 'Córdoba, Argentina',
  pack: PACK,
  time: 'hace 15 min'
}, {
  name: 'Valentina C.',
  location: 'Montevideo, Uruguay',
  pack: PACK,
  time: 'hace 17 min'
}, {
  name: 'Rodrigo B.',
  location: 'Asunción, Paraguay',
  pack: PACK,
  time: 'hace 19 min'
}, {
  name: 'Daniela V.',
  location: 'Quito, Ecuador',
  pack: PACK,
  time: 'hace 21 min'
}, {
  name: 'Esteban N.',
  location: 'Guayaquil, Ecuador',
  pack: PACK,
  time: 'hace 23 min'
}, {
  name: 'Gabriela P.',
  location: 'Caracas, Venezuela',
  pack: PACK,
  time: 'hace 25 min'
}, {
  name: 'Fernando A.',
  location: 'La Paz, Bolivia',
  pack: PACK,
  time: 'hace 27 min'
}, {
  name: 'Carolina H.',
  location: 'San José, Costa Rica',
  pack: PACK,
  time: 'hace 29 min'
}, {
  name: 'Javier O.',
  location: 'Ciudad de Panamá, Panamá',
  pack: PACK,
  time: 'hace 31 min'
}, {
  name: 'Mariana D.',
  location: 'San Salvador, El Salvador',
  pack: PACK,
  time: 'hace 33 min'
}, {
  name: 'Pablo E.',
  location: 'Ciudad de Guatemala, Guatemala',
  pack: PACK,
  time: 'hace 35 min'
}, {
  name: 'Verónica S.',
  location: 'Tegucigalpa, Honduras',
  pack: PACK,
  time: 'hace 37 min'
}, {
  name: 'Ricardo M.',
  location: 'Santo Domingo, República Dominicana',
  pack: PACK,
  time: 'hace 39 min'
}];
export function PurchaseToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setHasScrolled(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (!hasScrolled) return;
    const showNext = () => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
      setCurrentIndex(prev => (prev + 1) % purchases.length);
    };
    const interval = setInterval(showNext, 12000);
    // Show first one immediately after scroll trigger
    showNext();
    return () => clearInterval(interval);
  }, [hasScrolled]);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-257">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: -50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -50
    }} className="fixed top-4 left-4 right-4 md:left-1/2 md:-translate-x-1/2 z-[100] bg-white border border-blue-100 p-3 md:p-4 rounded-xl shadow-2xl flex items-center gap-3 md:gap-4 max-w-sm mx-auto" data-id="element-258">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xs md:text-base shrink-0" data-id="element-259">
            {currentPurchase.name.charAt(0)}
          </div>
          <div className="flex-1" data-id="element-260">
            <div className="flex items-center justify-between" data-id="element-261">
              <p className="text-[11px] md:text-sm font-bold text-slate-900" data-id="element-262">
                {currentPurchase.name} de {currentPurchase.location} (
                {currentPurchase.pack})
                <span className="inline-block w-1.5 h-1.5 bg-green-500 rounded-full ml-1" data-id="element-263"></span>
              </p>
              <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-264">
                <X size={14} data-id="element-265" />
              </button>
            </div>
            <p className="text-xs text-slate-600" data-id="element-266">
              compró el{' '}
              <span className="text-blue-600 font-bold" data-id="element-267">
                {currentPurchase.pack}
              </span>
            </p>
            <p className="text-[10px] text-slate-400 mt-1" data-id="element-268">
              {currentPurchase.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}